/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccountsRecoveryDatesListParams,
  PaginatedRecoveryDateList,
  RecoveryDate,
  RecoveryDateRequest
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * History of a member's recovery counter, newest first. Patients see their own; staff see members they are authorized for.
 * @summary List recovery date changes
 */
export const accountsRecoveryDatesList = (
    params?: AccountsRecoveryDatesListParams,
 options?: SecondParameter<typeof apiV2<PaginatedRecoveryDateList>>,) => {
      return apiV2<PaginatedRecoveryDateList>(
      {url: `/accounts/recovery-dates/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Record the authenticated user's recovery date. Resubmitting the current date is a no-op and returns 200 rather than creating a duplicate.
 * @summary Set the recovery date
 */
export const accountsRecoveryDatesCreate = (
    recoveryDateRequest: RecoveryDateRequest,
 options?: SecondParameter<typeof apiV2<RecoveryDate>>,) => {
      return apiV2<RecoveryDate>(
      {url: `/accounts/recovery-dates/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: recoveryDateRequest
    },
      options);
    }
  /**
 * A base View for consolidating organization related view attributes and methods.
 */
export const accountsRecoveryDatesRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<RecoveryDate>>,) => {
      return apiV2<RecoveryDate>(
      {url: `/accounts/recovery-dates/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * The authenticated user's current recovery date and streak length, or 204 when they have never set one.
 * @summary Current recovery date
 */
export const accountsRecoveryDatesCurrentRetrieve = (

 options?: SecondParameter<typeof apiV2<RecoveryDate | void>>,) => {
      return apiV2<RecoveryDate | void>(
      {url: `/accounts/recovery-dates/current/`, method: 'GET'
    },
      options);
    }
  export type AccountsRecoveryDatesListResult = NonNullable<Awaited<ReturnType<typeof accountsRecoveryDatesList>>>
export type AccountsRecoveryDatesCreateResult = NonNullable<Awaited<ReturnType<typeof accountsRecoveryDatesCreate>>>
export type AccountsRecoveryDatesRetrieveResult = NonNullable<Awaited<ReturnType<typeof accountsRecoveryDatesRetrieve>>>
export type AccountsRecoveryDatesCurrentRetrieveResult = NonNullable<Awaited<ReturnType<typeof accountsRecoveryDatesCurrentRetrieve>>>
